import React from 'react';

import { PopoverRoot } from '@bestdoctor/spectrum-uikit/PopoverRoot';
import { PopoverTrigger } from '@bestdoctor/spectrum-uikit/PopoverTrigger';
import { PopoverContent } from '@bestdoctor/spectrum-uikit/PopoverContent';
import { Dropdown } from '@bestdoctor/spectrum-uikit/Dropdown';
import { Stack } from '@bestdoctor/spectrum-uikit/Stack';
import { Text } from '@bestdoctor/spectrum-uikit/Text';
import { ProgressBar } from '@bestdoctor/spectrum-uikit/ProgressBar';

import { IStatsCompanyByPatients } from 'interfaces/global/globalInterfaces';

interface TooltipTotalStatsProps {
  open: boolean;
  isStats: IStatsCompanyByPatients;
  children: React.ReactElement;
  handleTooltipClose: () => void;
}

interface StatRowProps {
  value: number;
  label: string;
}

const PERCENTAGE_WIDTH = 56;
const STAT_TEXT_WIDTH = 150;

const formatPercent = (value: number): string =>
  Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`;

const StatRow: React.FC<StatRowProps> = ({ value, label }) => (
  <Stack direction="horizontal" gap="5" style={{ alignItems: 'center' }}>
    <ProgressBar value={value} max={100} style={{ flex: 1 }} />
    <Stack direction="horizontal" gap="5" style={{ alignItems: 'baseline', width: STAT_TEXT_WIDTH, flexShrink: 0 }}>
      <Text
        as="span"
        variant="body-m"
        color={{ surface: 'light', variant: 'primary' }}
        style={{ minWidth: PERCENTAGE_WIDTH }}
      >
        {formatPercent(value)}
      </Text>
      <Text as="span" variant="body-m" color={{ surface: 'light', variant: 'ghost' }}>
        {label}
      </Text>
    </Stack>
  </Stack>
);

const TooltipTotalStats: React.FC<TooltipTotalStatsProps> = ({ open, isStats, children, handleTooltipClose }) => (
  <PopoverRoot
    open={open}
    onOpenChange={(isOpen) => {
      if (!isOpen) handleTooltipClose();
    }}
  >
    <PopoverTrigger asChild>{children}</PopoverTrigger>
    <PopoverContent side="bottom" align="end" sideOffset={8}>
      <Dropdown style={{ padding: 'var(--spacing-6x)', width: 687 }}>
        <Stack gap="8">
          <Text variant="heading-3">Общая информация</Text>

          <Stack gap="12">
            <Stack gap="2">
              <Text variant="heading-5" color={{ surface: 'light', variant: 'secondary' }}>
                Человек в системе
              </Text>
              <Stack direction="horizontal" gap="20" style={{ alignItems: 'center' }}>
                <Text variant="title-xl" color={{ surface: 'light', variant: 'brand-additional' }}>
                  {isStats.total_registered}
                </Text>
                <Stack gap="2" style={{ flex: 1, alignSelf: 'center' }}>
                  <StatRow value={isStats.men_percentage} label="Мужчины" />
                  <StatRow value={isStats.women_percentage} label="Женщины" />
                </Stack>
              </Stack>
            </Stack>

            <Stack gap="3">
              <Text variant="heading-5" color={{ surface: 'light', variant: 'secondary' }}>
                Распределение по возрасту
              </Text>
              <Stack gap="2">
                <StatRow value={isStats.less_30} label="до 30" />
                <StatRow value={isStats.more_30_and_less_45} label="30-45" />
                <StatRow value={isStats.more_45_and_less_60} label="45-60" />
                <StatRow value={isStats.more_60} label="60+" />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Dropdown>
    </PopoverContent>
  </PopoverRoot>
);

export { TooltipTotalStats };
